export const SAVE_JWT = 'SAVE_JWT';
export const AUTHORIZED = 'AUTHORIZED';
export const UN_AUTHORIZED = 'UN_AUTHORIZED';
